/**
 * 校园缴费相关
 * 接口文档https://note.youdao.com/s/WMa1tEbs
 * 原型https://fd4dy8.axshare.com
 * 1、改动接口（收费明细列表）
 *增加参数：  query_type 查询类型【1：学生名，2：手机号】
 *参数：query_value  查询内容【类型1时，则是学生名，2是则是手机号】
 *地址：http://rap2.10niu.cn/repository/editor?id=96&mod=480&itf=3281
 *2、新增导出接口（导出缴费订单列表）
 *地址：http://rap2.10niu.cn/repository/editor?id=96&mod=480&itf=4157
 * 校园缴费v1.2.0: http://rap2.10niu.cn/repository/editor?id=96&mod=639&itf=4166
 */
/**
 * 后端技术方案：https://note.youdao.com/s/C1GnYpRq
 * 校园缴费v1.3.0原型：https://fd4dy8.axshare.com
 * 接口地址: http://rap2.10niu.cn/repository/editor?id=96&mod=663&itf=4311
 */
import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const newPayment = {
	// 创建账单（选择名单方式）
	addBill_choose(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-fee/v1/add_bill_by_choose`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 创建账单（上传名单方式）
	addBill_update(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-fee/v1/add_bill_by_upload`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//创建账单（上传名单方式）-验证表格数据
	checkUpdate(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-fee/v1/check_upload_data`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//账单列表
	getBillList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/school-fee/v1/bill_list`,
			headers: config.headers,
			params
		});
	},
	//账单详情
	getBillInfo(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/school-fee/v1/bill_info`,
			headers: config.headers,
			params
		});
	},
	//收费明细列表
	feeOrderList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/school-fee/v1/fee_order_list`,
			headers: config.headers,
			params
		});
	},
	//催交/一键催交
	call(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-fee/v1/fee_order_call`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//调整收费时间
	updateDeadlines(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-fee/v1/update_bill_deadlines`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//停止账单
	stopBill(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-fee/v1/stop_bill`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//开启账单
	openBill(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-fee/v1/open_bill`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//费用明细账单详情
	feeOrderInfo(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/school-fee/v1/fee_order_info`,
			headers: config.headers,
			params
		});
	},
	//标记不参与
	notParticipate(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-fee/v1/fee_order_not_participate`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//标记未支付
	unpaid(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-fee/v1/fee_order_unpaid`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//获取支付账单收费项目列表
	getFeeItems(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/school-fee/v1/fee_order_fee_items`,
			headers: config.headers,
			params
		});
	},
	//标记支付账单（线下支付）
	offlinePay(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-fee/v1/offline_payment`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 撤回支付信息
	cancelPay(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-fee/v1/cancel_offline_payment`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	//学校微信支付配置信息
	pay_config(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/school-fee/v1/wechat_pay_config`,
			headers: config.headers,
			params
		});
	},
	//导出缴费订单列表
	exportFeeOrderList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/school-fee/v1/export_fee_order_list`,
			headers: config.headers,
			params
		});
	},
	// 校园缴费v1.2_后台_学校商户配置列表
	merchantList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/school-fee/v1/merchant_list`,
			headers: config.headers,
			params
		});
	},
	// 校园缴费v1.2_后台_根据代理商ID批量设置商户分账
	batch_set_profitsharing(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-fee/v1/batch_set_profitsharing`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 校园缴费v1.2_后台_商户分账配置
	set_profitsharing(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-fee/v1/set_profitsharing`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 校园缴费v1.2_后台_获取分账设置详情
	get_profitsharing(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/school-fee/v1/get_profitsharing`,
			headers: config.headers,
			params
		});
	},
	// 校园缴费v1.2_后台_学校商户关闭分账
	close_profitsharing(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-fee/v1/close_profitsharing`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 校园缴费v1.2_后台_用户账单关闭分账
	close_bill_profitsharing(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-fee/v1/close_bill_profitsharing`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 校园缴费v1.2_后台_用户账单开启分账
	open_bill_profitsharing(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school-fee/v1/open_bill_profitsharing`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 校园缴费v1.2_后台_分账关系列表
	profitsharing_relation(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/school-fee/v1/profitsharing_relation`,
			headers: config.headers,
			params
		});
	},
	// 校园缴费v1.2_后台_获取分账默认设置
	default_profitsharing_config(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/school-fee/v1/default_profitsharing_config`,
			headers: config.headers,
			params
		});
	},
	// 校园缴费v1.2_后台_获取商户最大分账比例
	merchant_config(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/school-fee/v1/merchant_config`,
			headers: config.headers,
			params
		});
	},
	// 后台_校园缴费_收款码_创建
	addCode(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school_payment_code/v1/add`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_校园缴费_收款码_编辑
	editCode(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school_payment_code/v1/edit`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_校园缴费_收款码_列表
	getCodeList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/school_payment_code/v1/list`,
			headers: config.headers,
			params
		});
	},
	// 后台_校园缴费_收款码_详情
	getCodeInfo(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/school_payment_code/v1/info`,
			headers: config.headers,
			params
		});
	},
	// 后台_校园缴费_收款码_缴费明细
	getFeeList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/school_payment_code/v1/fee_list`,
			headers: config.headers,
			params
		});
	},
	// 后台_校园缴费_收款码_缴费明细 (导出用)
	getFeeInfoList(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/school_payment_code/v1/fee_info_list`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 后台_校园缴费_收款码_缴费明细详情
	getFeeInfo(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/school_payment_code/v1/fee_info`,
			headers: config.headers,
			params
		});
	}
};

export default newPayment;
